export default "__VITE_ASSET__ac511b23__"